import routerOptions0 from "/app/node_modules/.pnpm/nuxt@3.20.2_@parcel+watcher@2.5.1_@types+node@20.19.26_@vue+compiler-sfc@3.5.25_cac@6.7.14_db_bzc7rhuygxramow2nkbqrysiby/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}